import React from 'react';

function cx(...classes) {
  return classes.filter(Boolean).join(' ');
}

export function Card({ children, className = '', padded = true, ...rest }) {
  return (
    <div
      className={cx(
        'bg-white rounded-xl border border-neutral-200 shadow-subtle dark:bg-ink-900 dark:border-neutral-700',
        padded && 'p-6',
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({ title, subtitle, action, className = '' }) {
  return (
    <div className={cx('px-5 py-4 border-b border-neutral-100 flex justify-between items-center bg-white dark:border-neutral-800 dark:bg-ink-900', className)}>
      <div>
        <h3 className="font-bold text-neutral-800 text-sm dark:text-neutral-100">{title}</h3>
        {subtitle && <p className="text-xs text-neutral-500 mt-1 dark:text-neutral-400">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export default Card;
